module.exports = __webpack_public_path__ + "img/statement_b.c1e75157.png";